import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function LettersIcon({ className }: IconProps) {
  return (
    <svg
      width="76"
      height="47"
      viewBox="0 0 76 47"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1934)">
        <path
          d="M75.9998 3.28809V44.9077C75.9998 46.0606 75.0657 47.0001 73.9335 47.0001H15.3555L75.9998 3.28809Z"
          fill="#EAEDF8"
        />
        <path
          d="M60.6585 46.9999L0 3.13135V44.9075C0 46.0605 0.934078 46.9999 2.08045 46.9999"
          fill="#D6DBE7"
        />
        <path
          d="M15.3557 47.0001L37.9717 30.6454L0 3.28809V44.9077C0 46.0606 0.934078 47.0001 2.06629 47.0001H15.3415H15.3557Z"
          fill="#EAEDF8"
        />
        <path
          d="M36.7263 31.0012C37.0942 31.3001 37.5613 31.4709 38 31.4709C38.4387 31.4709 38.9058 31.3001 39.2879 31.0012C48.4588 23.742 76.0142 4.93913 76.0142 4.93913V3.28801C76 1.46608 74.5423 0 72.7307 0H3.11359C1.40112 0 0 1.40915 0 3.13144V4.98183C0 4.98183 27.5553 23.742 36.7263 30.987"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1934">
          <rect width="76" height="47" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
